/**
 * Appends a remaining URL suffix (query string, fragment, or path) to a base URL.
 *
 * - `remaining` starting with `?`, `#`, `/` is appended directly.
 * - Anything else is assumed to be a query string and `?` is prepended.
 * - Returns `baseUrl` unchanged when either argument is empty.
 */
export const appendRemainingUrl = (baseUrl: string, remaining: string): string => {
  if (!remaining || !baseUrl) {
    return baseUrl;
  }
  if (remaining.startsWith("?") || remaining.startsWith("#") || remaining.startsWith("/")) {
    return `${baseUrl.replace(/\/+$/, "")}${remaining}`;
  }
  return `${baseUrl.replace(/\/+$/, "")}?${remaining}`;
};
